module.exports = __webpack_public_path__ + "media/images/flags/16/Portugal-098308ae90e4d18f0d115692917de474.png";